<div class="row">

<!--  Project Header  -->
    <div *ngIf="dataLoaded" class="col-12">
        <div class="card card-custom gutter-b project-header">
            <div class="card-header border-0">
                <div class="card-title">
                    <h1 class="card-label m-0">{{ projectData.projectName | titlecase}}</h1>
                </div>
                <div class="card-toolbar">
                    <button *ngIf="isAllowedToEdit" type="button" class="btn-back mr-3" routerLink="/projects/edit/{{projectData.id}}">
                        <span class="fas fa-pen"></span>
                    </button>
                    <button type="button" class="btn-back" routerLink="/projects/list">
                        <span class="fa fa-arrow-left"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>

<!--  Project Description  -->
    <div *ngIf="dataLoaded" class="col-12 col-xl-8">
        <div class="card card-custom gutter-b">
            <div class="card-header border-0">
                <div class="card-title">
                    <h3 class="card-label m-0">General Details</h3>
                </div>
            </div>

            <div class="card-body d-flex flex-column justify-content-between">
                <div class="row">
                <!-- Description -->
                    <div class="col-12 col-md-8 mb-6 mb-md-0">
                        <p class="form-label">
                            Description
                        </p>
                        <textarea readonly class="blue-scroll-bar"
                                  [value]="projectData.description === null ? 'No description' : projectData.description">
                        </textarea>
                    </div>
                <!-- Client Details -->
                    <div class="col-12 col-md-4 mb-6 mb-md-0">
                        <p class="form-label">
                            Client details
                        </p>
                        <div class="client-tile">
                            <div class="d-flex align-items-center">
                                <span class="fas fa-user"></span>
                                <p>{{ projectData.clientName === '' ? 'None' :  projectData.clientName}}</p>
                            </div>

                            <div class="d-flex align-items-center">
                                <span class="fas fa-envelope"></span>
                                <p>{{ projectData.clientEmail === '' ? 'None' :  projectData.clientEmail}}</p>
                            </div>

                            <div class="d-flex align-items-center">
                                <span class="fas fa-phone"></span>
                                <p>{{ projectData.clientPhone === '' ? 'None' :  projectData.clientPhone}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4 mb-6 mb-md-0">
                        <div class="project-tile">
                            <span>{{ projectData.budget }}</span>
                            <span>Budget</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-6 mb-md-0">
                        <div class="project-tile">
                            <span>{{ teamMembers.length }}</span>
                            <span>
                                {{teamMembers.length === 0 ? 'Members'
                                : teamMembers.length === 1 ? 'Member'
                                : 'Members'}}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="project-tile">
                            <span>{{ projectData.startDate | date: 'd MMMM, y' }}</span>
                            <span>Start Date</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!--  Project Completion  -->
    <div *ngIf="dataLoaded && completionLoaded" class="col-12 col-xl-4">
        <div class="card card-custom gutter-b">
            <div class="card-header border-0">
                <div class="card-title">
                    <h3 class="card-label m-0">Completion</h3>
                </div>
                <div class="card-toolbar">
                    <button type="button" class="btn btn-clean btn-hover-light-primary btn-lg btn-icon">
                        <span class="fas fa-ellipsis-h"></span>
                    </button>
                </div>
            </div>

            <div class="card-body d-flex flex-column align-items-center justify-content-between project-completion">
                <apx-chart
                        [series]="chartOptions.series"
                        [chart]="chartOptions.chart"
                        [xaxis]="chartOptions.xaxis"
                        [yaxis]="chartOptions.yaxis"
                        [dataLabels]="chartOptions.dataLabels"
                        [stroke]="chartOptions.stroke"
                        [legend]="chartOptions.legend"
                        [fill]="chartOptions.fill"
                        [states]="chartOptions.states"
                        [tooltip]="chartOptions.tooltip"
                        [colors]="chartOptions.colors"
                        [markers]="chartOptions.markers"
                        [plotOptions]="chartOptions.plotOptions"
                ></apx-chart>
                <p class="mb-8">Tasks completed</p>
                <div class="progress mb-2">
                    <div class="progress-bar {{barClass}}" role="progressbar" style="width: {{progressBar}}%">{{progressBar}}%</div>
                </div>
                <p class="m-0">Due date</p>
                <span style="color: {{spanColor}}">{{projectData.deadline | date: 'd MMMM, y' }}</span>
            </div>
        </div>
    </div>

<!--  Gantt Chart  -->
    <div *ngIf="dataLoaded" class="col-12">
        <div class="card card-custom gutter-b">
            <div class="card-header border-0">
                <div class="card-title">
                    <h3 class="card-label m-0">Project Timeline</h3>
                </div>
                <div class="card-toolbar">

                    <button *ngIf="isAllowedToEdit" type="button" class="btn-default btn-green flex-row-reverse add-button" (click)="openModal(addStage)">
                        <span translate="PROJECTS.STAGE"></span>
                        <span class="fas fa-plus mr-3"></span>
                    </button>

                    <ng-template #addStage let-c="close">
                        <div class="modal-header">
                            <h3 class="modal-title" translate="PROJECTS.CREATE_STAGE"></h3>
                            <button type="button" class="btn-back" (click)="c()">
                                <span class="fa fa-arrow-left"></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                                              [customSuccessMessage]="successMsg"></app-form-message>

                            <form [formGroup]="newStageForm" (ngSubmit)="submitStageForm()">
                                <div class="row">
                                    <div class="col-12 form-group">
                                        <p class="form-label">Stage Name</p>
                                        <input class="form-control form-control-lg form-layout"
                                               type="text"
                                               formControlName="name"
                                               [class.is-invalid]="isControlInvalid('name')">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                                            This field is required!
                                        </div>
                                    </div>

                                    <div class="col-12 form-group d-flex justify-content-between align-items-center">
                                        <p class="form-label m-0">Stage Color</p>
                                        <div ngbDropdown class="d-inline-block">
                                            <button [ngClass]="newStageForm.value.color" type="button" class="btn btn-success btn-color" id="colorDropdown" ngbDropdownToggle>
                                                <span class="fas fa-fill-drip"></span>
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="colorDropdown">
                                                <button *ngFor="let color of colorsClasses"
                                                        class="dropdown-item btn-color" type="button"
                                                        [ngClass]="color"
                                                        (click)="newStageForm.controls['color'].setValue(color)">
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 form-group">
                                        <p class="form-label">Start Date</p>
                                        <input class="form-control form-control-lg form-layout"
                                               type="date"
                                               formControlName="startDate"
                                               [class.is-invalid]="isControlInvalid('startDate')">
                                        <div class="invalid-feedback" *ngIf="controlHasError('startDateIsBiggerThanEndDate', 'startDate')">
                                            Start Date can't be bigger than End Date
                                        </div>
                                        <div class="invalid-feedback" *ngIf="controlHasError('isEmpty', 'startDate')">
                                            This field is required
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 form-group">
                                        <p class="form-label">End Date</p>
                                        <input class="form-control form-control-lg form-layout"
                                               type="date"
                                               formControlName="endDate"
                                               [class.is-invalid]="isControlInvalid('endDate')">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'endDate')">
                                            This field is required!
                                        </div>
                                    </div>

                                    <div class="col-12 form-group">
                                        <p class="form-label">Description</p>
                                        <textarea class="form-control form-control-lg form-layout"
                                                  type="text" rows="4"
                                                  formControlName="description"></textarea>
                                    </div>

                                    <div class="col-12 d-flex justify-content-end">
                                        <button type="submit" class="btn-default btn-green" [disabled]="isDisabled">
                                            Create
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div *ngIf="!stagesExist" class="card-body d-flex justify-content-center align-items-center">
                <h1>Add a stage to your project</h1>
            </div>

            <div *ngIf="stagesExist" class="card-body gantt-chart blue-scroll-bar" id="contextContainer">
                <div>
                    <ngx-ts
                            [items]="items"
                            [periods]="periods"
                            [sections]="sections"
                            [events]="events"
                            [showBusinessDayOnly]="false"
                            [allowDragging]="true"
                            [start]="startDate"
                    ></ngx-ts>
                    <!--Nu sterge-->
                    <!--<div id="contextMenu">
                        <p>{{selectedItem}}</p>
                    </div>-->
                </div>
            </div>
        </div>
    </div>

<!--  Project Tasks List  -->
    <div class="col-12">
        <div class="card card-custom gutter-b custom-table">
            <div class="card-header flex-column border-0">
                <div class="d-flex justify-content-between flex-wrap">
                    <div *ngIf="!viewRemovedTasks" class="card-title">
                        <h3 class="card-label m-0">{{selectedList}}</h3>
                    </div>

                    <div *ngIf="viewRemovedTasks" ngbDropdown class="card-label d-flex align-items-center">
                        <button class="btn tasks-dropdown" id="tasksList" ngbDropdownToggle>
                            <h3 class="sub-title m-0">
                                {{selectedList}}
                                <span class="fas fa-caret-down ml-1"></span>
                            </h3>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="tasksList">
                            <button class="dropdown-item">
                                <h3 class="sub-title">
                                    {{selectedList}}
                                    <span class="fas fa-caret-up ml-1"></span>
                                </h3>
                            </button>
                            <button class="dropdown-item" (click)="changeList()">
                                <h3 class="sub-title">
                                    {{listName}}
                                </h3>
                            </button>
                        </div>
                    </div>

                    <div class="card-toolbar">
                        <button *ngIf="isAllowedToEdit" type="button" class="btn-default btn-green flex-row-reverse add-button"
                                (click)="openModal(addTask)">
                            <span translate="PROJECTS.TASK"></span>
                            <span class="fas fa-plus mr-3"></span>
                        </button>

<!--                    Nu sterge, o sa-l folosim mai tarziu

                        <ng-template #addTask let-c = "close">
                            <app-task-modal [closeRef]="c" [projectData]="projectData"></app-task-modal>
                        </ng-template>-->

                        <ng-template #addTask let-c="close">
                            <div class="modal-header">
                                <h3 class="modal-title" translate="PROJECTS.NEW_TASK"></h3>
                                <button type="button" class="btn-back" (click)="c()">
                                    <span class="fa fa-arrow-left"></span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                                                  [customSuccessMessage]="successMsg"></app-form-message>

                                <form [formGroup]="newTaskForm" (ngSubmit)="submitTaskForm()">
                                    <div class="row">
                                        <div class="col-12 form-group">
                                            <p class="form-label">Task Name</p>
                                            <input class="form-control form-control-lg form-layout"
                                                   type="text"
                                                   formControlName="name"
                                                   [class.is-invalid]="isControlInvalidAlt('name')">
                                            <div class="invalid-feedback" *ngIf="controlHasErrorAlt('required', 'name')">
                                                This field is required!
                                            </div>
                                        </div>

                                        <div class="col-12 form-group">
                                            <p class="form-label">Description</p>
                                            <textarea class="form-control form-control-lg form-layout"
                                                      formControlName="description"
                                            ></textarea>
                                        </div>

                                        <div class="col-12 form-group">
                                            <p class="form-label">Due Date</p>
                                            <input class="form-control form-control-lg form-layout"
                                                   type="date"
                                                   formControlName="dueDate"
                                                   [class.is-invalid]="isControlInvalidAlt('dueDate')">
                                            <div class="invalid-feedback" *ngIf="controlHasErrorAlt('required', 'dueDate')">
                                                This field is required!
                                            </div>
                                        </div>

                                        <div class="col-12 form-group">
                                            <p class="form-label">Responsible Member</p>
                                            <select class="form-control form-control-lg form-layout custom-select"
                                                    formControlName="responsible">
                                                <option *ngIf="teamMembers.length === 0"
                                                        [ngValue]="''">
                                                    None
                                                </option>
                                                <option *ngFor="let user of teamMembers"
                                                        [ngValue]="user.id">
                                                    {{user.firstName + ' ' + user.lastName}}
                                                </option>
                                            </select>

                                        </div>

                                        <div class="col-12 form-group">
                                            <p class="form-label">Project Stage</p>
                                            <select class="form-control form-control-lg form-layout custom-select"
                                                    formControlName="stage">
                                                <option [ngValue]="0">
                                                    None
                                                </option>
                                                <option *ngFor="let stage of projectStage"
                                                        [ngValue]="stage.position">
                                                    {{stage.name}}
                                                </option>
                                            </select>

                                        </div>

                                        <div class="col-12 form-group">
                                            <p class="form-label">New checklist item</p>
                                            <div class="d-flex justify-content-between align-items-center mb-5">
                                                <input class="form-control form-control-lg form-layout"
                                                       type="text" #subTaskInput>
                                                <button type="button" class="btn-default btn-green ml-4"
                                                        (click)="pushSubTask(subTaskInput.value)">
                                                    <span class="fas fa-plus"></span>
                                                </button>
                                            </div>

                                            <p *ngIf="subTasks.length > 0" class="form-label">Task Checklist:</p>
                                            <div *ngFor="let subTask of subTasks; let i = index"
                                                 class="d-flex justify-content-between align-items-center mb-3">
                                                <p>{{ subTask.description }}</p>
                                                <button type="button" class="btn-list btn-red"
                                                        (click)="removeSubTask(i)">
                                                    <span class="fas fa-trash-alt"></span>
                                                </button>
                                            </div>

                                        </div>

                                        <div class="col-12 d-flex justify-content-end">
                                            <button type="submit" class="btn-default btn-green">
                                                Create
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <p class="toggle-filters mt-5 mb-0" role="button" (click)="toggleFilters()">
                    <span *ngIf="hideFilters" class="fas fa-angle-down mr-1"></span>
                    <span *ngIf="!hideFilters" class="fas fa-angle-up mr-1"></span>
                    {{ hideFilters ? 'Show Filters' : 'Hide Filters' }}
                </p>
            </div>

            <div class="card-body">

                <div id="filtersRow" class="filter-row row">
                    <div class="table-selection
                        col-12 col-sm-5 col-md-3 col-xl-2">
                        <label>Stage</label>
                        <select class="form-control form-control-lg form-layout custom-select" name="search-type" id="stage">
                            <option value="">All</option>
                            <option *ngFor="let stage of stages">{{stage}}</option>
                        </select>
                    </div>

                    <div class="table-search
                        col-12 col-sm-5 col-md-3 col-xl-3
                        ml-sm-auto">
                        <label>Search</label>
                        <input id="tableSearchBox">
                        <span class="fas fa-search"></span>
                    </div>

                </div>

                <div class="table-loader">

                    <!--spinner while fetching new data-->
                    <div id="mySpinner" class="spinner-background">
                        <div class="spinner-border text-primary"></div>
                    </div>

                    <table id="myTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table nowrap compact hover order-column">
                        <thead>
                        <tr>
                            <th>Nr</th>
                            <th>Task Name</th>
                            <th>Stage</th>
                            <th>Due Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let task of selectedTasks; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ task.messageTitle }}</td>
                            <td>{{ task.projectStage !== 0 ? stages[task.projectStage] : 'None'}}</td>
                            <td>{{ task.deadline | date: 'yyyy/MM/dd'}}</td>
                            <td>{{ task.status }}</td>
                            <td>
                                <div class="d-flex justify-content-end">
                                    <button type="button" ngbTooltip="View" class="btn-list btn-main"
                                            [ngClass]="{'mr-2' : isAllowedToEdit}"
                                            routerLink="/projects/{{projectData.id}}/{{task.id}}/view"><span class="far fa-eye"></span>
                                    </button>

                                    <button *ngIf="isAllowedToEdit" type="button" ngbTooltip="Edit" class="btn-list btn-main"
                                            [ngClass]="{'mr-2' : viewRemovedTasks && selectedList === 'Current Tasks'}"
                                            routerLink="/projects/{{projectData.id}}/{{task.id}}/edit"><span class="fas fa-pen"></span>
                                    </button>

                                    <button *ngIf="viewRemovedTasks && selectedList === 'Current Tasks'"
                                            type="button" ngbTooltip="Remove" class="btn-list btn-red"
                                            (click)="openRemoveTaskModal(removeTaskModal)">
                                        <span class="fas fa-trash"></span>
                                    </button>

                                    <ng-template #removeTaskModal let-c="close">
                                        <div class="modal-header">
                                            <h3 class="modal-title" translate="PROJECTS.DELETE_TASK"></h3>
                                            <button type="button" class="btn-back" (click)="c()">
                                                <span class="fa fa-arrow-left"></span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            <p class="m-0">
                                                Are you sure you want to delete this task?
                                            </p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn-default btn-main mr-5 border-0 flex-row-reverse"
                                                    (click)="c()"
                                                    translate="GENERAL.NO">
                                                <span class="fas fa-times mr-3"></span>
                                            </button>

                                            <button type="button" class="btn-default btn-red border-0 flex-row-reverse"
                                                    (click)="removeTask(i, task.id); c()"
                                                    translate="GENERAL.YES">
                                                <span class="fas fa-save mr-3"></span>
                                            </button>
                                        </div>
                                    </ng-template>
                                </div>
                            </td>
                            <td>
                                <!-- empty table data -->
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

<!--  Team Members  -->
    <div class="col-12 col-md-8">
        <div class="card card-custom gutter-b members-list">
            <div class="card-header border-0">
                <div class="card-title">
                    <h3 class="card-label m-0">Team Members</h3>
                </div>
                <div class="card-toolbar">
                    <button *ngIf="isAllowedToEdit" type="button" class="btn-default btn-green flex-row-reverse add-button"
                            (click)="openModal(addMember)">
                        <span translate="PROJECTS.MEMBER"></span>
                        <span class="fas fa-plus mr-3"></span>
                    </button>

                    <ng-template #addMember let-c="close">
                        <div class="modal-header">
                            <h3 class="modal-title" translate="PROJECTS.ADD_NEW_MEMBER"></h3>
                            <button type="button" class="btn-back" (click)="c()">
                                <span class="fa fa-arrow-left"></span>
                            </button>
                        </div>
                        <div class="modal-body modal-members">
                            <app-form-message *ngIf="formSent" [success]="formResponse" [customErrorMessage]="errorMsg"
                                              [customSuccessMessage]="successMsg"></app-form-message>

                            <div *ngFor="let user of allTeam" class="row align-items-center mb-4">
                                <div class="col-5 col-sm-4 d-flex align-items-center pr-0">
                                    <img src="{{user.profileImagePath}}">
                                    <p class="bold-text ml-3">{{user.firstName + ' ' + user.lastName}}</p>
                                </div>

                                <div class="col-5 col-sm-4 d-flex justify-content-center">
                                    <p>{{ (user.department === '' || user.department === null) ? 'No Department' :
                                           user.department }}</p>
                                </div>

                                <div class="col-2 col-sm-4 d-flex justify-content-end">
                                    <button type="button" class="btn-default btn-green add-member" (click)="addNewMember(user)">
                                        <span class="fas fa-plus"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="card-body">
                <div *ngFor="let member of teamMembers | slice:0:4" class="row align-items-center mb-4">
                    <div class="col-5 col-sm-4 d-flex align-items-center pr-0">
                        <img src="{{member.image}}">
                        <p class="bold-text ml-3">{{member.firstName + ' ' + member.lastName}}</p>
                    </div>

                    <div class="col-5 col-sm-4 d-flex justify-content-center">
                        <p>{{ (member.dep === '' || member.dep === null) ? 'No Department' : member.dep }}</p>
                    </div>

                    <div *ngIf="isAllowedToEdit" class="col-2 col-sm-4 d-flex justify-content-end">
                        <div ngbDropdown class="card-label">
                            <button type="button" class="btn btn-clean btn-hover-light-primary btn-lg btn-icon"
                                    id="membersDropdown" ngbDropdownToggle>
                                <span class="fas fa-ellipsis-h"></span>
                            </button>
                            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="membersDropdown">
                                <button class="dropdown-item" (click)="removeMember(member.id)">
                                    Remove Member
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-footer">
                <button *ngIf="teamMembers.length > 4" (click)="openModal(allMembers)">
                    <p class="bold-text">View All Members</p>
                </button>

                <ng-template #allMembers let-c="close">
                    <div class="modal-header">
                        <h3 class="modal-title" translate="PROJECTS.ALL_MEMBERS"></h3>
                        <button type="button" class="btn-back" (click)="c()">
                            <span class="fa fa-arrow-left"></span>
                        </button>
                    </div>
                    <div class="modal-body modal-members">
                        <div *ngFor="let member of teamMembers" class="row align-items-center mb-4">
                            <div class="col-5 col-sm-4 d-flex align-items-center pr-0">
                                <img src="{{member.image}}">
                                <p class="bold-text ml-3">{{member.firstName + ' ' + member.lastName}}</p>
                            </div>

                            <div class="col-5 col-sm-4 d-flex justify-content-center">
                                <p>{{ member.dep === '' ? 'No Department' : member.dep }}</p>
                            </div>

                            <div *ngIf="isAllowedToEdit" class="col-2 col-sm-4 d-flex justify-content-end">
                                <div ngbDropdown class="card-label">
                                    <button type="button" class="btn btn-clean btn-hover-light-primary btn-lg btn-icon"
                                            id="allMembersDropdown" ngbDropdownToggle>
                                        <span class="fas fa-ellipsis-h"></span>
                                    </button>
                                    <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="allMembersDropdown">
                                        <button class="dropdown-item" (click)="removeMember(member.id)">
                                            Remove Member
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>


<!--  Attachements  -->
    <div class="col-12 col-md-4">
        <div class="card card-custom gutter-b">
            <div class="card-body attachments-wrapper">
                <!--Attachments-->
                <app-add-attachments moduleName="project"></app-add-attachments>
            </div>
        </div>
    </div>

    <!--Admin Notes-->
    <div class="col-12 mb-10 notes-wrapper">
        <app-admin-notes moduleName="project"></app-admin-notes>
    </div>
</div>

